import { render, staticRenderFns } from "./Tools.vue?vue&type=template&id=04d6a892&scoped=true&"
import script from "./Tools.vue?vue&type=script&lang=js&"
export * from "./Tools.vue?vue&type=script&lang=js&"
import style0 from "./Tools.vue?vue&type=style&index=0&id=04d6a892&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d6a892",
  null
  
)

export default component.exports